import { VerticalPlotter } from "./verticalPlotter";
import { ViewModel } from "../../settings/viewModel";
import { PlotDefinition, ChartType, ValueChart } from "../../definitions";
import { DataProperty, Scenario } from "../../library/constants";

export class ResponsivePlotter extends VerticalPlotter {
    constructor(
        viewModel: ViewModel,
        width: number,
        height: number,
        reportArea: d3.Selection<SVGElement, any, any, any>,
        svg: d3.Selection<SVGElement, any, any, any>,
        locale: string
    ) {
        super(viewModel, width, height, reportArea, svg, locale);
    }

    // tslint:disable-next-line: max-func-body-length
    protected getPlotDefinitions(): PlotDefinition[] {
        let plotDefinitions: PlotDefinition[] = [];
        let plotDefinition: PlotDefinition;
        if (!this.viewModel.HasValueColumn) {
            plotDefinition = this.getBlankPlotDefinition(1);
            plotDefinitions.push(plotDefinition);
            return plotDefinitions;
        }
        if (this.viewModel.hasHierarchy) {
            plotDefinition = this.getBlankPlotDefinition(0.7);
            if (this.viewModel.reference.scenario === Scenario.PreviousYear) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.Table,
                    DataProperty.ReferenceValue,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.Value, DataProperty.ReferenceValue, false, false);
            } else {
                this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.Value, DataProperty.ReferenceValue, false, false);
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.Table,
                    DataProperty.ReferenceValue,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            this.addChartDefinition(
                plotDefinition,
                ChartType.AbsoluteChart,
                DataProperty.AbsoluteDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            this.addChartDefinition(
                plotDefinition,
                ChartType.PlusMinusDot,
                DataProperty.RelativeDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            plotDefinitions.push(plotDefinition);

            plotDefinition = this.getBlankPlotDefinition(1);
            if (this.viewModel.reference.scenario === Scenario.PreviousYear) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.Table,
                    DataProperty.ReferenceValue,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.Value, DataProperty.ReferenceValue, false, false);
            } else {
                this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.Value, DataProperty.ReferenceValue, false, false);
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.Table,
                    DataProperty.ReferenceValue,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            this.addChartDefinition(
                plotDefinition,
                ChartType.AbsoluteChart,
                DataProperty.AbsoluteDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            this.addChartDefinition(
                plotDefinition,
                ChartType.Table,
                DataProperty.RelativeDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            plotDefinitions.push(plotDefinition);

            plotDefinition = this.getBlankPlotDefinition(1);
            if (this.viewModel.reference.scenario === Scenario.PreviousYear) {
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.Table,
                    DataProperty.ReferenceValue,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.Value, DataProperty.ReferenceValue, false, false);
            } else {
                this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.Value, DataProperty.ReferenceValue, false, false);
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.Table,
                    DataProperty.ReferenceValue,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
            }
            this.addChartDefinition(
                plotDefinition,
                ChartType.AbsoluteChart,
                DataProperty.AbsoluteDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            plotDefinitions.push(plotDefinition);

            plotDefinition = this.getBlankPlotDefinition(1);
            this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.Value, DataProperty.ReferenceValue, false, false);
            this.addChartDefinition(
                plotDefinition,
                ChartType.AbsoluteChart,
                DataProperty.AbsoluteDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            plotDefinitions.push(plotDefinition);

            plotDefinition = this.getBlankPlotDefinition(1);
            this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.Value, DataProperty.ReferenceValue, false, false);
            this.addChartDefinition(
                plotDefinition,
                ChartType.Table,
                DataProperty.AbsoluteDifference,
                DataProperty.ReferenceValue,
                false,
                false
            );
            plotDefinitions.push(plotDefinition);

            plotDefinition = this.getBlankPlotDefinition(1);
            this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.Value, DataProperty.ReferenceValue, false, false);
            plotDefinitions.push(plotDefinition);
        } else {
            plotDefinition = this.getBlankPlotDefinition(0.8);
            if (this.settings.valueChart === ValueChart.Waterfall || this.settings.valueChart === ValueChart.CalculationWaterfall) {
                if (this.viewModel.reference.scenario === Scenario.PreviousYear) {
                    this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.ReferenceValue, DataProperty.Value, false, false);
                }
                this.addChartDefinition(plotDefinition, ChartType.ValueChart, DataProperty.Value, DataProperty.Value, false, false);
                if (this.viewModel.reference.scenario !== Scenario.PreviousYear) {
                    this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.ReferenceValue, DataProperty.Value, false, false);
                }
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.AbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.RelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                plotDefinitions.push(plotDefinition);

                plotDefinition = this.getBlankPlotDefinition(1);
                this.addChartDefinition(plotDefinition, ChartType.ValueChart, DataProperty.Value, DataProperty.Value, false, false);
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.AbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.RelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                plotDefinitions.push(plotDefinition);

                plotDefinition = this.getBlankPlotDefinition(1);
                this.addChartDefinition(plotDefinition, ChartType.ValueChart, DataProperty.Value, DataProperty.Value, false, false);
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.AbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.Table,
                    DataProperty.RelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                plotDefinitions.push(plotDefinition);

                plotDefinition = this.getBlankPlotDefinition(0.8);
                this.addChartDefinition(plotDefinition, ChartType.ValueChart, DataProperty.Value, DataProperty.ReferenceValue, true, true);
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.RelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                plotDefinitions.push(plotDefinition);

                plotDefinition = this.getBlankPlotDefinition(1);
                this.addChartDefinition(plotDefinition, ChartType.ValueChart, DataProperty.Value, DataProperty.ReferenceValue, true, true);
                plotDefinitions.push(plotDefinition);
            } else {
                if (this.viewModel.reference.scenario === Scenario.PreviousYear) {
                    this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.ReferenceValue, DataProperty.Value, false, false);
                }
                this.addChartDefinition(plotDefinition, ChartType.ValueChart, DataProperty.Value, DataProperty.Value, false, false);
                if (this.viewModel.reference.scenario !== Scenario.PreviousYear) {
                    this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.ReferenceValue, DataProperty.Value, false, false);
                }
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.AbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.RelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                plotDefinitions.push(plotDefinition);

                plotDefinition = this.getBlankPlotDefinition(1);
                this.addChartDefinition(plotDefinition, ChartType.ValueChart, DataProperty.Value, DataProperty.Value, false, false);
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.AbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.RelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                plotDefinitions.push(plotDefinition);

                plotDefinition = this.getBlankPlotDefinition(1);
                this.addChartDefinition(plotDefinition, ChartType.ValueChart, DataProperty.Value, DataProperty.Value, false, false);
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.AbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.Table,
                    DataProperty.RelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                plotDefinitions.push(plotDefinition);

                plotDefinition = this.getBlankPlotDefinition(1);
                this.addChartDefinition(plotDefinition, ChartType.ValueChart, DataProperty.Value, DataProperty.Value, false, false);
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.AbsoluteChart,
                    DataProperty.AbsoluteDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.Table,
                    DataProperty.RelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                plotDefinitions.push(plotDefinition);

                plotDefinition = this.getBlankPlotDefinition(0.8);
                this.addChartDefinition(plotDefinition, ChartType.ValueChart, DataProperty.Value, DataProperty.ReferenceValue, true, true);
                this.addChartDefinition(
                    plotDefinition,
                    ChartType.PlusMinusDot,
                    DataProperty.RelativeDifference,
                    DataProperty.ReferenceValue,
                    false,
                    false
                );
                plotDefinitions.push(plotDefinition);

                plotDefinition = this.getBlankPlotDefinition(1);
                this.addChartDefinition(plotDefinition, ChartType.ValueChart, DataProperty.Value, DataProperty.ReferenceValue, true, true);
                plotDefinitions.push(plotDefinition);
            }
        }
        return plotDefinitions;
    }
}
